module.exports = __webpack_public_path__ + "static/media/btn-logout.a8fd9179.svg";